module.exports = __webpack_public_path__ + "static/media/07_california_temperature_map.3205e419.png";